export enum ShiftRequestStatusEnum {
  Pending = 'pending',
  Negotiating = 'negotiating',
  ContractorAccepted = 'contractor_accepted',
  Accepted = 'accepted',
  Declined = 'declined',
  Expired = 'expired',
  Withdrawn = 'withdrawn',
  AutoDeclined = 'auto_declined',
  Cancelled = 'cancelled'
}
